import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Excess from './excess.jsx';

export default class ThisDriversArchivedExcesses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/excesses',
      excessAccountId: props.excessAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/excesses/'+
      this.state.excessAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(excessesJson) {
      that.setState({
        excesses: excessesJson,
        isLoading: false
      });
    });
  }

  render() {
    var Excesses = [];

    if (this.state.excesses && this.state.excesses.length > 0) {
      this.state.excesses.forEach(function(i) {
          Excesses.push(<Excess key={'excess-'+i.id} data={i} />);
        });
    }
    return (
      <div>
        <div className="row excesses-table-header">
          <div className="col-md-3">
          description
          </div>
          <div className="col-md-3">
          reference
          </div>
          <div className="col-md-2">
          amounts
          </div>
          <div className="col-md-2">
          frequency
          </div>
          <div className="col-md-2">
          details
          </div>
        </div>
        {Excesses}
      </div>
    );
  }
}
